import { Card, CardBody, CardHeader, Typography } from '@la/ds-ui-components';
import { Tournament } from '@la/types';
import { convertToKebabCase } from '@la/utilities';
import { isFree } from '../utils/cost';
import { buildFees } from '../utils/fees';
import styles from './FeesCard.module.scss';
import { formatCostRange } from './utils/cost';

export const NO_FEES_TEXT = 'There are currently no fees for this program.';
export const FREE_TEXT = 'Free';

export type Fee = {
  label: string;
  min: string;
  max: string;
};

export type FeesCardProps = {
  fees: Fee[];
  showTeamPlayerFees?: boolean;
  showTeamStaffFees?: boolean;
};

/* FeesCard */
export function FeesCard({
  tournamentData,
}: Readonly<{ tournamentData: Tournament }>) {
  const fees = buildFees(tournamentData);
  const { showTeamPlayerFees, showTeamStaffFees } = tournamentData;

  return (
    <div className={styles.feesCard}>
      <Card>
        <CardHeader>Fees</CardHeader>
        <CardBody>
          {fees.length === 0 ? (
            <Typography className={styles.noFees} size="large" variant="ui">
              {NO_FEES_TEXT}
            </Typography>
          ) : null}
          {fees
            .filter((fee) => {
              if (fee.label === 'Team Player') {
                return showTeamPlayerFees;
              }
              if (fee.label === 'Team Staff Member') {
                return showTeamStaffFees;
              }
              return true;
            })
            .map((fee) => (
              <div key={convertToKebabCase(fee.label)} className={styles.fee}>
                <Typography size="large" variant="ui" weight="bold">
                  {fee.label}
                </Typography>
                <Typography size="large" variant="ui">
                  {isFree(fee.max)
                    ? FREE_TEXT
                    : formatCostRange(fee.min, fee.max)}
                </Typography>
              </div>
            ))}
        </CardBody>
      </Card>
    </div>
  );
}
/* */
